module.exports = __webpack_public_path__ + "static/media/forward-to-email-icon.d81f087d.svg";